// extracted by mini-css-extract-plugin
export var active = "_2l-2";
export var container = "_2l-0";
export var expired = "_2l-3";
export var hasStatus = "_2l-4";
export var statusChip = "_2l-1";